module.exports = "<div ng-message=required><translate>uxf.uxf.Required</translate></div><div ng-message=gzRegexValidator><translate>uxf.uxf.Validation_Invalid</translate></div>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/validation/messages.jade
// module id = 255
// module chunks = 0